import React from 'react';
import styles from './testimonial.module.scss';


class Testimonial extends React.Component {
  render () {
    return (
      <blockquote>
        {this.props.children}
        <cite>{this.props.cite}</cite>
        <p><a href={this.props.to}>Learn more about {this.props.cite}'s transformation!</a></p>
      </blockquote>
    )
  }
}

export default Testimonial;


// WEBPACK FOOTER //
// ./src/components/Testimonial/index.js